import React, { useState, useEffect } from "react";
import BaseEmailComponent from "../BaseEmailComponent";
import EmailImageUpload from "../EmailImageUpload";
import "../EmailDetails.css";
import { Form } from "react-bootstrap";

const ThreeIconContent = ({ id, data, onUpdate, styleSettings }) => {
  const [image1, setImage1] = useState(data?.image1 || null);
  const [image2, setImage2] = useState(data?.image2 || null);
  const [image3, setImage3] = useState(data?.image3 || null);

  // Update images when data changes
  useEffect(() => {
    if (data) {
      setImage1(data.image1 || null);
      setImage2(data.image2 || null);
      setImage3(data.image3 || null);
    }
  }, [data]);

  // Handle image updates
  const handleImage1Upload = (imageData) => {
    setImage1(imageData);
  };

  const handleImage2Upload = (imageData) => {
    setImage2(imageData);
  };

  const handleImage3Upload = (imageData) => {
    setImage3(imageData);
  };

  // Edit UI with forms and image uploads
  const renderEditUI = ({ title, setTitle, description, setDescription, handleSaveChanges, styleSettings }) => {
    // Function to save all changes at once
    const saveAllChanges = () => {
      handleSaveChanges(title, description, { image1, image2, image3 });
    };

    return (
      <div className="row p-3 rounded" style={{ backgroundColor: 'white' }}>
        <div className="col-12 mb-3">
          <Form.Group className="mb-3">
            <Form.Label><strong>Title</strong></Form.Label>
            <Form.Control
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onBlur={saveAllChanges}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label><strong>Description</strong></Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              onBlur={saveAllChanges}
            />
          </Form.Group>
        </div>

        <div className="col-md-4">
          <EmailImageUpload
            initialImage={image1}
            onImageUpload={handleImage1Upload}
            allowRegenerate={true}
            label="Image 1"
          />
        </div>

        <div className="col-md-4">
          <EmailImageUpload
            initialImage={image2}
            onImageUpload={handleImage2Upload}
            allowRegenerate={true}
            label="Image 2"
          />
        </div>

        <div className="col-md-4">
          <EmailImageUpload
            initialImage={image3}
            onImageUpload={handleImage3Upload}
            allowRegenerate={true}
            label="Image 3"
          />
        </div>
      </div>
    );
  };

  // View UI for display mode
  const renderViewUI = ({ title, description, styleSettings }) => {
    const { primaryColor, secondaryColor, fontFamily } = styleSettings || {};

  return (
      <div className="row">
        <div className="col-12 mb-4 text-center">
          <h3 style={{ 
            fontSize: "24px", 
            marginBottom: "12px",
            color: primaryColor || "#333333",
            fontFamily
          }}>
            {title}
          </h3>
          <p className="description-text" style={{ 
            fontFamily,
            color: "#666666"
          }}>
            {description}
          </p>
      </div>

        <div className="col-md-4 text-center">
          <div className="rounded mb-3 d-flex justify-content-center align-items-center">
            {image1 ? (
              <img src={image1} alt="Feature 1" className="img-fluid rounded" style={{ maxHeight: "120px" }} />
                  ) : (
              <div className="d-flex align-items-center justify-content-center outline-none rounded" style={{ height: "120px" }}>
                <img
                  src="/img-preview.svg"
                  alt="Feature 1 placeholder"
                  className="img-fluid rounded"
                  style={{ maxHeight: "120px" }}
                />
                    </div>
                  )}
                </div>
          <h5 style={{ 
            fontSize: "18px", 
            fontWeight: "bold",
            color: primaryColor || "#333333",
            fontFamily
          }}>Feature 1</h5>
          <p style={{ 
            fontSize: "14px",
            fontFamily,
            color: "#666666"
          }}>Feature description goes here</p>
                </div>

        <div className="col-md-4 text-center">
          <div className="rounded mb-3 d-flex justify-content-center align-items-center">
            {image2 ? (
              <img src={image2} alt="Feature 2" className="img-fluid rounded" style={{ maxHeight: "120px" }} />
                  ) : (
              <div className="d-flex align-items-center justify-content-center outline-none rounded" style={{ height: "120px" }}>
                <img
                  src="/img-preview.svg"
                  alt="Feature 2 placeholder"
                  className="img-fluid rounded"
                  style={{ maxHeight: "120px" }}
                />
                    </div>
                  )}
                </div>
          <h5 style={{ 
            fontSize: "18px", 
            fontWeight: "bold",
            color: primaryColor || "#333333",
            fontFamily
          }}>Feature 2</h5>
          <p style={{ 
            fontSize: "14px",
            fontFamily,
            color: "#666666"
          }}>Feature description goes here</p>
        </div>

        <div className="col-md-4 text-center">
          <div className="rounded mb-3 d-flex justify-content-center align-items-center">
            {image3 ? (
              <img src={image3} alt="Feature 3" className="img-fluid rounded" style={{ maxHeight: "120px" }} />
            ) : (
              <div className="d-flex align-items-center justify-content-center outline-none rounded" style={{ height: "120px" }}>
                <img
                  src="/img-preview.svg"
                  alt="Feature 3 placeholder"
                  className="img-fluid rounded"
                  style={{ maxHeight: "120px" }}
                />
              </div>
            )}
          </div>
          <h5 style={{ 
            fontSize: "18px", 
            fontWeight: "bold",
            color: primaryColor || "#333333",
            fontFamily
          }}>Feature 3</h5>
          <p style={{ 
            fontSize: "14px",
            fontFamily,
            color: "#666666"
          }}>Feature description goes here</p>
      </div>
    </div>
  );
};

  return (
    <BaseEmailComponent
      id={id}
      data={data}
      onUpdate={onUpdate}
      componentName="Three Feature Icons"
      styleSettings={styleSettings}
      editUI={renderEditUI}
      viewUI={renderViewUI}
    />
  );
};

export default ThreeIconContent;
